import { EntityContext, findNode, FormNode, readMessageModelByCode, ValidationMessageGroup } from '@msdk/definitions'

export function applyServerMessages(
  form: FormNode | undefined,
  messages: ValidationMessageGroup[],
  context: EntityContext,
) {
  const messageEntities = messages ?? []
  messageEntities.forEach((e) => {
    const alias = context.getAliasFromEntityId(e.id)
    if (alias !== undefined) {
      const entityFields = Object.keys(e.items)
      entityFields.forEach((f) => {
        const fieldName = alias != '' ? `${alias}.${f}` : f
        const fieldMessages = e.items[f]
        const node = findNode(form, fieldName)
        if (fieldMessages && node) {
          const toAdd = fieldMessages.messages.map((m) => m.code)
          let params = (fieldMessages.messages.map((m) => m.params).flat() as string[]) ?? []

          /**
           * the server side validation returns the error message with the description already
           * interpolated and traslated, given how the form works client side cicle trough the
           * server messages and extract the parameters that where used, so we can treat server
           * messages like any other message without the need of special handling inside the form
           */
          fieldMessages.messages.forEach((m) => {
            const message = readMessageModelByCode(m.code)
            const paramToAdd = extractParameters(message?.description as string, m.description) ?? []
            params = [...params, ...paramToAdd].filter((p) => !!p)
          })

          const current = node.value.validationMessages ?? []
          node.value.validationMessages = current.concat(toAdd)
          node.value.validationParams = params ?? []
        }
      })
    }
  })
}

function findMessageGroup(start: ValidationMessageGroup[], id: string): ValidationMessageGroup | undefined {
  let found: ValidationMessageGroup | undefined = undefined
  const startingGroup = start || []
  for (let i = 0; i < startingGroup.length; i++) {
    const current = startingGroup[i]
    if (current.id === id) {
      found = current
      break
    }

    const keys = Object.keys(current.items)
    for (let j = 0; j < keys.length; j++) {
      const currentKey = keys[j]
      const currentItem = current.items[currentKey]
      const foundRow = findMessageGroup(currentItem.rows, id)
      if (foundRow) {
        found = foundRow
        break
      }
    }
  }
  return found
}

/**
 * Given a template string and the result of the string.format this method
 * will extract the parameters that where used to format that string
 * @param template the template with the placeholders
 * @param formattedString the result of the string.format
 * @returns the parameters that wher used in the string.format
 */
function extractParameters(template: string, formattedString: string) {
  // Escape special characters in the template and replace placeholders with regex patterns
  let regexString = template.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&') // Escape special characters
  regexString = regexString.replace(/\\\{[0-9]+\\\}/g, '(.*)') // Replace placeholders

  // Create a RegExp object
  const regex = new RegExp(regexString)

  // Match the formatted string against the regex
  const match = formattedString.match(regex)

  // Extract captured groups if match is found
  if (match) {
    return match.slice(1) // Returns an array of captured groups
  }

  return null // No match found
}
